// src/pages/Dashboard/Admin/DetailsAdherents/components/ManagersPanel.jsx

import React from "react";
import { FaEnvelope } from "react-icons/fa";
import DashboardDataTable from "./DashboardDataTable";
import { getRoleClass } from "../utils/adherentDashboardUtils";

function Badge({ children, className }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ring-1 ${className}`}
    >
      {children}
    </span>
  );
}

export default function ManagersPanel({ managers, roles }) {
  const getRoleName = (roleId) =>
    roles.find((role) => Number(role.id) === Number(roleId))?.nom ||
    "Rôle inconnu";

  return (
    <DashboardDataTable
      minWidth="900px"
      columns={[
        {
          key: "user",
          label: "Utilisateur",
          render: (row) => (
            <div>
              <p className="font-semibold text-slate-900 dark:text-white">
                {(row?.nom || "").toUpperCase()} {row?.prenom || ""}
              </p>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                ID #{row?.id}
              </p>
            </div>
          ),
        },
        {
          key: "email",
          label: "Email",
          render: (row) => row?.email || "—",
        },
        {
          key: "role",
          label: "Rôle",
          render: (row) => (
            <Badge className={getRoleClass(row?.role_id)}>
              {getRoleName(row?.role_id)}
            </Badge>
          ),
        },
        {
          key: "action",
          label: "Action",
          render: (row) =>
            row?.email ? (
              <a
                href={`mailto:${row.email}`}
                className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                <FaEnvelope />
                Email
              </a>
            ) : (
              "—"
            ),
        },
      ]}
      rows={managers}
      emptyMessage="Aucun gestionnaire lié à cet adhérent."
    />
  );
}